import { render, staticRenderFns } from "./mallGoodsAdd.vue?vue&type=template&id=2fffb9e2&"
import script from "./mallGoodsAdd.vue?vue&type=script&lang=js&"
export * from "./mallGoodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./mallGoodsAdd.vue?vue&type=style&index=0&id=2fffb9e2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports